const comments = [
  {
    name: '光影追梦人',
    date: '2026-07-28',
    text: '用了90影视快两年了，资源更新速度确实快，每次有新片上映没几天就能在站点找到高清版。播放流畅度也很满意，基本没有卡顿的情况。推荐给了身边不少朋友。',
    stars: 5,
  },
  {
    name: '周末电影迷',
    date: '2026-07-25',
    text: '无意中发现90影视这个宝藏网站，界面简洁干净，没有烦人的弹窗广告。片源很全，连一些比较冷门的老片子都能找到。现在是我的主力观影平台了。',
    stars: 5,
  },
  {
    name: '追剧小能手',
    date: '2026-07-22',
    text: '作为一个重度追剧党，90影视的日韩剧更新速度真的没话说。每周同步更新，翻译质量也很不错。APP版支持投屏，在家用大电视看太爽了。',
    stars: 4,
  },
  {
    name: '电影发烧友Leo',
    date: '2026-07-18',
    text: '资源库的IMDB高分片很齐全，画质清晰度大部分在1080P以上。唯一的建议是希望分类标签能再细化一些，比如按导演、演员分类，找片会更方便。总体体验很棒。',
    stars: 4,
  },
  {
    name: '深夜观影者',
    date: '2026-07-15',
    text: '90影视的多线路切换功能非常实用，遇到高峰期也能流畅播放。网站访问速度快，移动端页面适配做得也很好，手机上看体验不输APP。会一直支持下去。',
    stars: 5,
  },
];

export default function CommentsSection() {
  const renderStars = (count: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i key={i} className={`text-xs ${i < count ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}></i>
    ));
  };

  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户好评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自90影视用户的真实评价与观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((c, i) => (
            <div key={i} className={`bg-background-50 rounded-xl border border-background-200/60 p-5 ${i >= 3 ? 'lg:col-span-1' : ''}`}>
              <div className="flex items-center gap-1 mb-2">
                {renderStars(c.stars)}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{c.text}</p>
              <div className="flex items-center justify-between pt-3 border-t border-background-200/60">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <span className="text-xs font-bold text-accent-600">{c.name[0]}</span>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{c.name}</span>
                </div>
                <span className="text-xs text-foreground-400">{c.date}</span>
              </div>
            </div>
          ))}
          {comments.length === 5 && (
            <div className="hidden lg:block lg:col-span-3"></div>
          )}
        </div>
      </div>
    </section>
  );
}